<div class="entity-tables" [class.entity-tables-document]="documentStyle">
  <lib-gung-accordion class="party-accordion">
    @for (party of glnAddressList; track party.title; let first = $first) {
      <lib-gung-accordion-item [id]="party.title" [collapsed]="!first">
        <ng-template libGungAccordionHeader>
          <span class="party-role">{{ partyRole(party) }}</span>
          <span class="party-summary">{{ partySummary(party) }}</span>
        </ng-template>
        <ng-template libGungAccordionBody>
          <ng-container *ngTemplateOutlet="partyDetails; context: { $implicit: party }"></ng-container>
        </ng-template>
      </lib-gung-accordion-item>
    }
  </lib-gung-accordion>
</div>

<!-- Empty fields are left out; most parties only carry a few of them -->
<ng-template #partyDetails let-party>
  @if (party.gln) {
    <div class="gln">
      <div class="table-label">GLN</div>
      <div class="table-data">{{ party.gln }}</div>
    </div>
  }
  @if (party.externalId?.id) {
    <div class="line-data">
      <div class="table-label">EXTERNAL ID</div>
      <div class="table-data">{{ party.externalId.id }}</div>
    </div>
  }
  @if (party.name) {
    <div class="line-data">
      <div class="table-label">{{ 'COMPANY' | translate }}</div>
      <div class="table-data">{{ party.name | translate }}</div>
    </div>
  }
  @if (party.customerId) {
    <div class="line-data">
      <div class="table-label">{{ 'CUSTOMER_ID' | translate }}</div>
      <div class="table-data">{{ party.customerId }}</div>
    </div>
  }
  @if (party.erpCustomerId) {
    <div class="line-data">
      <div class="table-label">{{ party.erpCustomerIdLabel | translate }}</div>
      <div class="table-data">{{ party.erpCustomerId }}</div>
    </div>
  }
  @if (party.customerName) {
    <div class="line-data">
      <div class="table-label">{{ 'CUSTOMER_NAME' | translate }}</div>
      <div class="table-data">{{ party.customerName }}</div>
    </div>
  }
  @if (party.address1 || party.address2) {
    <div class="line-data">
      <div class="table-label">{{ 'ADDRESS' | translate }}</div>
      <div class="table-data">{{ party.address1 }} {{ party.address2 }}</div>
    </div>
  }
  @if (party.zipCode) {
    <div class="line-data">
      <div class="table-label">{{ 'POSTAL_CODE' | translate }}</div>
      <div class="table-data">{{ party.zipCode }}</div>
    </div>
  }
  @if (party.city) {
    <div class="line-data">
      <div class="table-label">{{ 'CITY' | translate }}</div>
      <div class="table-data">{{ party.city }}</div>
    </div>
  }
  @if (party.countryCode) {
    <div class="line-data">
      <div class="table-label">{{ 'COUNTRY' | translate }}</div>
      <div class="table-data">{{ party.countryCode }}</div>
    </div>
  }
  @if (party.phone) {
    <div class="line-data">
      <div class="table-label">{{ 'PHONE' | translate }}</div>
      <div class="table-data">{{ party.phone }}</div>
    </div>
  }
  @if (party.vatNumber) {
    <div class="line-data">
      <div class="table-label">{{ 'VAT_NUMBER' | translate }}</div>
      <div class="table-data">{{ party.vatNumber }}</div>
    </div>
  }
  @if (party.orgNumber) {
    <div class="line-data">
      <div class="table-label">{{ 'ORG_NUMBER' | translate }}</div>
      <div class="table-data">{{ party.orgNumber }}</div>
    </div>
  }
  @if (party.bankName) {
    <div class="line-data">
      <div class="table-label">{{ 'BANK_NAME' | translate }}</div>
      <div class="table-data">{{ party.bankName }}</div>
    </div>
  }
  @if (party.bankAccountNumber) {
    <div class="line-data">
      <div class="table-label">{{ 'BANK_ACCOUNT' | translate }}</div>
      <div class="table-data">{{ party.bankAccountNumber }}</div>
    </div>
  }
</ng-template>
